import { useId } from 'react';

import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { useTheme } from 'styled-components';

type ViewStreamProps = IconComponentBaseProps;

export const ViewStream = ({ width = 16, height = 16, fill, className }: ViewStreamProps) => {
  const theme = useTheme();
  const id = useId();
  const iconFill = fill || theme.mantineColors.gray[7];

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask id={id} style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill={iconFill} />
      </mask>
      <g mask={`url(#${id})`}>
        <path
          d="M12.6668 11.1275V8.49935H3.3335V11.1275C3.3335 11.1874 3.35272 11.2366 3.39116 11.275C3.42961 11.3135 3.47877 11.3327 3.53866 11.3327H12.4617C12.5216 11.3327 12.5707 11.3135 12.6092 11.275C12.6476 11.2366 12.6668 11.1874 12.6668 11.1275ZM12.6668 7.49935V4.87118C12.6668 4.81129 12.6476 4.76213 12.6092 4.72368C12.5707 4.68524 12.5216 4.66602 12.4617 4.66602H3.53866C3.47877 4.66602 3.42961 4.68524 3.39116 4.72368C3.35272 4.76213 3.3335 4.81129 3.3335 4.87118V7.49935H12.6668ZM3.53866 12.3327C3.20188 12.3327 2.91683 12.216 2.6835 11.9827C2.45016 11.7493 2.3335 11.4643 2.3335 11.1275V4.87118C2.3335 4.5344 2.45016 4.24935 2.6835 4.01602C2.91683 3.78268 3.20188 3.66602 3.53866 3.66602H12.4617C12.7984 3.66602 13.0835 3.78268 13.3168 4.01602C13.5502 4.24935 13.6668 4.5344 13.6668 4.87118V11.1275C13.6668 11.4643 13.5502 11.7493 13.3168 11.9827C13.0835 12.216 12.7984 12.3327 12.4617 12.3327H3.53866Z"
          fill={iconFill}
        />
      </g>
    </svg>
  );
};
